import React, { useEffect, useState, useContext } from "react";
import { getBatches3 } from "../api";
import { useNavigate, Link, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  Tooltip as RechartsTooltip,
  Legend as RechartsLegend,
  ComposedChart,
  BarChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

import renderActiveShape from "./renderActiveShape";
/*
import { Doughnut, Chart } from "react-chartjs-2";

import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

*/
import { handlePrint, handleDownloadCSV } from "../components/dataExport";
import Chart6 from "./chart6";
import { handleDownloadBatchCSV } from "../components/dataExportBatchDetail";

/*
// ✅ Registro de todos los tipos necesarios (bar, line, doughnut, etc.)
ChartJS.register(
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);
*/



const BatchList3 = ({ id_c }) => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();

  //para los graficos de pie
  const [activeIndex, setActiveIndex] = useState(0); // para controlar el slice activo
  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const [activeIndex2, setActiveIndex2] = useState(0);

  const onPieEnter2 = (_, index) => {
    setActiveIndex2(index);
  };


  // ✅ Recuperar id_batch y id_prod desde localStorage
  const id_batch = localStorage.getItem("selected_batch_id");
  const id_prod = localStorage.getItem("selected_prod_id");

  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({
    cant_oper: 0,
    cant_pt_ok: 0,
    cant_pt_nc: 0,
    total_hr_batch: 0,
    total_oper_batch: 0
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!id_batch || !id_prod || !id_c) {
        console.warn("❌ Falta información para filtrar los datos.");
        return;
      }

      const result = await getBatches3(id_c, id_batch, id_prod);
      setData(result);

      const suma = result.reduce((acc, item) => {
        acc.cant_oper += item.cant_oper || 0;
        acc.cant_pt_ok += item.cant_pt_ok || 0;
        acc.cant_pt_nc += item.cant_pt_nc || 0;
        acc.total_hr_batch += parseFloat(item.total_hr_batch || 0);
        acc.total_oper_batch += parseFloat(item.total_oper_batch || 0);
        return acc;
      }, {
        cant_oper: 0,
        cant_pt_ok: 0,
        cant_pt_nc: 0,
        total_hr_batch: 0,
        total_oper_batch: 0
      });

      setTotals(suma);
    };

    fetchData();
  }, [id_c, id_batch, id_prod]);

  if (!data.length) return <p>{t('MList1')}</p>;

  const totalOK = totals.cant_pt_ok;
  const totalNC = totals.cant_pt_nc;
  const totalPiezas = totalOK + totalNC;
  const porcentajeConformes = totalPiezas > 0 ? ((totalOK / totalPiezas) * 100).toFixed(2) : "0.00";



  // Calculo oper/ hour
  const total_oper_per_hour = totals.total_hr_batch > 0
    ? (totals.total_oper_batch / totals.total_hr_batch).toFixed(2)
    : "0.00";

  // ✅ Cálculo Total Operations Efficiency
  const oper_stdxhr = parseFloat(data[0]?.oper_stdxhr || 0);
  const eficienciaOperaciones = (totals.total_hr_batch > 0 && oper_stdxhr > 0)
    ? (((totals.total_oper_batch / totals.total_hr_batch) / oper_stdxhr) * 100).toFixed(2)
    : "0.00";

  // ✅ Cálculo Total Products Efficiency
  const undxoper = parseFloat(data[0]?.undxoper || 0);
  const eficienciaProductos = (totals.total_hr_batch > 0 && oper_stdxhr > 0)
    ? ((((totals.cant_pt_ok) / totals.total_hr_batch) / (oper_stdxhr * undxoper)) * 100).toFixed(2)
    : "0.00";




  //DATA PARA NEW CHARTS   //  RECHARTS CHARTS:



  //Para Conformidad
  const dataConformidad = [
    { name: t('batchList22') || "Producto Conforme", value: parseFloat(porcentajeConformes) },
    { name: t('batchList23') || "Producto No Conforme", value: 100 - parseFloat(porcentajeConformes) },
  ];
  const COLORS = ["#454958", "#ce649e"];

  // PARA EFICIENCIA OPERATIVA
  const eficienciaReal = oper_stdxhr > 0 ? ((total_oper_per_hour / oper_stdxhr) * 100).toFixed(2) : "0.00";
  const desviacion = oper_stdxhr > 0 ? ((oper_stdxhr - total_oper_per_hour) / oper_stdxhr * 100).toFixed(2) : "0.00";

  const dataEficienciaOperacion = [
    {
      name: t('batchList24') || "Desviación vs estándar",
      value: parseFloat(desviacion),
    },
    {
      name: t('batchList25') || "Eficiencia actual",
      value: parseFloat(eficienciaReal),
    },
  ];

  const COLORS2 = ["#2d5838ff", "#109443ff"];

  // Para Barras de Eficiencia contra estandar


  const chartDataCombo = data.map(batch => {
    const oper_per_hour = batch.total_hr_batch > 0 ? (batch.cant_oper / batch.total_hr_batch).toFixed(2) : 0;
    const date = new Date(batch.date_begin).toISOString().split("T")[0];

    return {
      date,
      oper_per_hour: parseFloat(oper_per_hour),
      oper_stdxhr: parseFloat(batch.oper_stdxhr || data[0]?.oper_stdxhr || 0)
    };
  });

  const chartDataProdPerHour = data.map(batch => {
    const und_per_hour = batch.total_hr_batch > 0 ? (batch.cant_pt_ok / batch.total_hr_batch).toFixed(2) : 0;
    const date = new Date(batch.date_begin).toISOString().split("T")[0];
    return {
      date,
      und_per_hour: parseFloat(und_per_hour),
      und_stdxhr: parseFloat(batch.und_stdxhr || data[0]?.und_stdxhr || 0)
    };
  });



  //CHARTS ------------------------------------------------------

  /*
      ChartJS.register(
    ArcElement,
    BarElement,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title
  );
  
  */
  //----------------------------------------------------
  //chart1 % CONFORMIDAD

  /*
//v1
  const chartColors = {
      orange: "#454958ff",
      blue: "#ce649eff",
  };

  const chartDataConformes = {
      labels: [t('batchList22'), t('batchList23')],
      datasets: [
          {
              data: [porcentajeConformes, 100 - porcentajeConformes],
              backgroundColor: [chartColors.orange, chartColors.blue],
              font:{
                  color: "#c5c5c5ff"},
              borderColor: ["#666666"]
              
          },
      ],
  };

  const chartOptionsConformes = {
      responsive: true,
      plugins: {
          legend: { position: "top" },
          title: { display: true, text: t('batchList16') },
      },
  };*/



  /*
      
      //v2
      const chartColors = {
    orange: "#454958ff", // Conformes
    blue: "#ce649eff",   // No conformes
  };
  
  const chartDataConformes = {
    labels: [t('batchList22') || "Conforming Product", t('batchList23') || "Non Conforming Product"],
    datasets: [
      {
        data: [porcentajeConformes, 100 - porcentajeConformes],
        backgroundColor: [chartColors.orange, chartColors.blue],
        borderColor: ["#999999", "#999999"], // ✅ color más claro para bordes
        borderWidth: 2,                      // opcional: puedes bajarlo a 1 si prefieres más fino
      },
    ],
  };
  
  const chartOptionsConformes = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: "#c5c5c5",     // ✅ color de texto de leyenda
          font: {
            size: 14,
          },
        },
      },
      title: {
        display: true,
        text: t('batchList16') || "Conforming Product (%)",
        color: "#c5c5c5",       // ✅ color de texto del título
        font: {
          size: 16,
          weight: "bold",
        },
      },
      tooltip: {
        bodyColor: "#ffffff",    // ✅ color del texto del tooltip
        titleColor: "#cccccc",
        backgroundColor: "#333333", // fondo del tooltip
      },
    },
  };
  */
  //----------------------------------------------------

  //----------------------------------------------------
  //chart2 OPERATIONS
  /*
  //v1
      const chartColors2 = {
          orange: "#5972a0ff",
          blue: "#133247ff",
      };
  
      const chartDataEfficiOper = {
          labels: [t('batchList24'),t('batchList25')],
          datasets: [
              {
                  data: [((oper_stdxhr - total_oper_per_hour) / oper_stdxhr) * 100, (total_oper_per_hour / oper_stdxhr) * 100],
                  backgroundColor: [chartColors2.orange, chartColors2.blue],
              },
          ],
      };
  
      const chartOptionsEfficiencOpera = {
          responsive: true,
          plugins: {
              legend: { position: "top" },
              title: { display: true, text: t('batchList14') },
          },
      };*/

  /*
  //v2
  const chartColors2 = {
orange: "#5972a0ff", // Diferencia contra estándar
blue: "#133247ff",   // Eficiencia actual
};

// Cálculo de datos en porcentaje (con validación)
const eficienciaReal = oper_stdxhr > 0 ? ((total_oper_per_hour / oper_stdxhr) * 100).toFixed(2) : 0;
const desviacion = oper_stdxhr > 0 ? ((oper_stdxhr - total_oper_per_hour) / oper_stdxhr * 100).toFixed(2) : 0;

const chartDataEfficiOper = {
labels: [t('batchList24') || "Desviación vs estándar", t('batchList25') || "Eficiencia actual"],
datasets: [
  {
    data: [desviacion, eficienciaReal],
    backgroundColor: [chartColors2.orange, chartColors2.blue],
    borderColor: ["#999999", "#999999"], // ✅ bordes claros
    borderWidth: 2,
  },
],
};

const chartOptionsEfficiencOpera = {
responsive: true,
plugins: {
  legend: {
    position: "top",
    labels: {
      color: "#c5c5c5", // ✅ texto claro en leyenda
      font: {
        size: 14,
      },
    },
  },
  title: {
    display: true,
    text: t('batchList14') || "Eficiencia de Operación",
    color: "#c5c5c5", // ✅ texto claro en título
    font: {
      size: 16,
      weight: "bold",
    },
  },
  tooltip: {
    bodyColor: "#ffffff",
    titleColor: "#cccccc",
    backgroundColor: "#333333",
  },
},
};
*/
  //----------------------------------------------------
  //CHART 3 BARRAS EFICIENCIA
  /*
      //v1
      const chartColorsCombo = {
          red: "rgb(255, 99, 132)",
          blue: "rgb(54, 162, 235)",
      };
  
      const transparentize = (color, opacity = 0.5) =>
          color.replace("rgb", "rgba").replace(")", `, ${opacity})`);
  
      // Labels = fechas
      const labelsCombo = data.map(batch =>
          new Date(batch.date_begin).toISOString().split("T")[0]
      );
  
      // Barra = operaciones por hora
      const bars_oper_per_hour = data.map(batch =>
          batch.total_hr_batch > 0 ? (batch.cant_oper / batch.total_hr_batch).toFixed(2) : 0
      );
  
      // Línea = oper_stdxhr repetido
      const line_oper_stdxhr = data.map(() =>
          parseFloat(data[0]?.oper_stdxhr || 0)
      );
  
      // Dataset combinado
      const dataCombo = {
          labels: labelsCombo,
          datasets: [
              {
                  label: t('labelOperPerHour') || "Operaciones por hora",
                  data: bars_oper_per_hour,
                  backgroundColor: transparentize(chartColorsCombo.red, 0.5),
                  borderColor: chartColorsCombo.red,
                  type: "bar",
                  order: 1,
              },
              {
                  label: t('batchList21') || "Estándar operaciones/hr",
                  data: line_oper_stdxhr,
                  backgroundColor: transparentize(chartColorsCombo.blue, 0.5),
                  borderColor: chartColorsCombo.blue,
                  type: "line",
                  order: 0,
              },
          ],
      };
  
      const optionsCombo = {
  responsive: true,
    plugins: {
      legend: { 
        position: "top",
        labels: {
          color: "#c5c5c5",
          font: {
            size: 14,
          },
        },
      },
      title: {
        display: true,
        text: t('batchList21') || "Operaciones por Hora vs Estándar",
        color: "#c5c5c5", // ✅ mismo color que otros títulos
        font: {
          size: 16,
          weight: "bold",
        },
      },
      tooltip: {
        bodyColor: "#ffffff",
        titleColor: "#cccccc",
        backgroundColor: "#333333",
      },
    },
  };
              
  
  
  */

  //----------------------------------------------------------------------

  return (
    <div className="body">
      <div className="">

        {/* Fila superior: tabla de detalle + torta de conformidad */}
        <div style={{ display: "flex", alignItems: "center", padding: "0 12px", boxSizing: "border-box", marginBottom: 24 }}>
          <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <table className="table6" style={{ width: "auto" }}>
              <tr>
                <th style={{ whiteSpace: "nowrap", minWidth: 330 }}>{t('batchList3')}</th><td>{data[0]?.id_prod || "-"}</td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap", minWidth: 330 }}>{t('batchList2')}</th><td>{data[0]?.cod_maq || "-"}</td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap", minWidth: 330 }}>{t('batchList12')}</th><td>{data[0]?.id_batch || "-"}</td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap", minWidth: 330 }}>{t('batchList18')}</th><td>{data[0]?.oper_stdxhr || "-"}</td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap", minWidth: 330 }}>{t('batchList17')}</th><td>{data[0]?.undxoper || "-"}</td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap", minWidth: 330 }}>{t('batchList19')}</th><td>{data[0]?.und_stdxhr || "-"}</td>
              </tr>
            </table>
          </div>

          <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <div style={{ width: 320, height: 300 }}>
              <h5 style={{ textAlign: "center" }}>{t('batchList16')}</h5>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    activeIndex={activeIndex}
                    activeShape={renderActiveShape}
                    data={dataConformidad}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={70}
                    outerRadius={95}
                    fill="#8884d8"
                    onMouseEnter={onPieEnter}
                  >
                    {dataConformidad.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        {/* Dos gráficas de barras */}
        <div className="chartsbox" style={{ display: "flex", gap: 8, alignItems: "flex-start", width: "100%", margin: 0, padding: "0 12px", boxSizing: "border-box" }}>

          <div style={{ flex: 1, minWidth: 0 }}>
            <h5>{t('batchList29')}</h5>
            <ResponsiveContainer width="100%" height={300}>
              <ComposedChart data={chartDataProdPerHour}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" stroke="#c5c5c5" />
                <YAxis stroke="#c5c5c5" />
                <Tooltip contentStyle={{ backgroundColor: "#333", color: "#fff" }} />
                <Legend />
                <Bar dataKey="und_per_hour" fill="rgba(255, 99, 132, 0.5)" name={t("batchList29")} />
                <Line type="monotone" dataKey="und_stdxhr" stroke="rgb(54, 162, 235)" name={t('batchList19')} />
              </ComposedChart>
            </ResponsiveContainer>
          </div>

          <div style={{ flex: 1, minWidth: 0 }}>
            <h5>{t('batchList18')}</h5>
            <ResponsiveContainer width="100%" height={300}>
              <ComposedChart data={chartDataCombo}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" stroke="#c5c5c5" />
                <YAxis stroke="#c5c5c5" />
                <Tooltip contentStyle={{ backgroundColor: "#333", color: "#fff" }} />
                <Legend />
                <Bar dataKey="oper_per_hour" fill="rgba(255, 99, 132, 0.5)" name={t("batchList21")} />
                <Line type="monotone" dataKey="oper_stdxhr" stroke="rgb(54, 162, 235)" name={t('batchList18')} />
              </ComposedChart>
            </ResponsiveContainer>
          </div>

        </div>

        <table className="table1">
          <thead>
            <tr>
              <th>{t('batchList7')}</th>
              <th>{t('batchList8')}</th>
              <th>{t('batchList10')}</th>
              <th>{t('batchList20')}</th>
              <th>{t('batchList27')}</th>
              <th>{t('batchList4')}</th>
              <th>{t('batchList21')}</th>
              <th>{t('batchList5')}</th>
              <th>{t('batchList6')}</th>
              <th>{t('batchList14')}</th>
              <th>{t('batchList15')}</th>
              <th>{t('batchList16')}</th>


            </tr>
          </thead>
          <tbody>


            {data.map((batch, index) => {
              const oper_per_hour = batch.total_hr_batch > 0
                ? (batch.cant_oper / batch.total_hr_batch).toFixed(2)
                : "0.00";

              return (
                <tr key={index}>
                  <td>{new Date(batch.date_begin).toISOString().split('T')[0]}</td>
                  <td>{batch.time_begin}</td>
                  <td>{batch.time_end}</td>
                  <td>{batch.total_hr_batch}</td>
                  <td>{batch.model}</td>

                  <td>{batch.cant_oper}</td>
                  <td>{oper_per_hour}</td> {/* ✅ Aquí lo usas */}
                  <td>{batch.cant_pt_ok}</td>
                  <td>{batch.cant_pt_nc}</td>
                  <td>{batch.percent_efficiency}</td>
                  <td>{batch.product_efficiency}</td>
                  <td>{batch.conforming_prod}</td>
                </tr>
              );
            })}

            <tr>
              <td colSpan={3}><strong>{t('Totales')}</strong></td>
              <td colSpan={2}><strong>{totals.total_hr_batch.toFixed(2)}</strong></td>
              <td><strong>{totals.total_oper_batch.toFixed(2)}</strong></td>
              <td><strong>{total_oper_per_hour}</strong></td>

              <td><strong>{totals.cant_pt_ok}</strong></td>
              <td><strong>{totals.cant_pt_nc}</strong></td>
              <td><strong>{eficienciaOperaciones}</strong></td>

              <td><strong>{eficienciaProductos}</strong></td>


              <td><strong>{porcentajeConformes}%</strong></td>

            </tr>
          </tbody>
        </table>

        <div className="buttongroup1">
          <button className="button8" onClick={handlePrint}>{t('oper15')}</button>
          <button className="button8" onClick={() =>
            handleDownloadBatchCSV(data, totals, total_oper_per_hour, eficienciaOperaciones, eficienciaProductos, porcentajeConformes)}>
            {t('Descargar CSV')}
          </button>
        </div>

      </div>
    </div>
  );
};

export default BatchList3;